import { Button } from '@/components/Button';
import { ContactBox } from '@/components/ContactBox';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { RemoteImage } from '@/components/RemoteImage';
import { ELoanUsage, setLoanUsage, setPaidAmount } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

export const baseId = 'screen-ineligible';

export function Ineligible(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChangeLoanUsage(): void {
        dispatch(setPaidAmount(undefined));
        // dispatch(setVehicleMake(undefined));
        // dispatch(setIsVehicleKnown(false));
        dispatch(setLoanUsage(ELoanUsage.PERSONAL));
        dispatch(setDisplay(EDisplays.QUICK_CALCULATOR));
    }

    return (
        <DisplayComponent baseId={baseId} data-testid={baseId}>
            <Header />
            <div className='flex-center pb-4 relative'>
                <div className='bg-primary h-40 w-40 rounded-full' />
                <RemoteImage fileName='coins.svg' className='absolute' />
            </div>
            <div className='text-center flex flex-col space-y-2'>
                <h3 className='uppercase text-xl text-primary font-bold'>
                    Unfortunately, you don’t meet the criteria for a novated
                    lease.
                </h3>
                <p className='text-secondary'>
                    We understand this may be disappointing.
                </p>
                <p className='text-secondary'>
                    A novated lease is a salary-packaged vehicle arrangement
                    that requires specific employment and financial conditions.
                </p>
                <p className='text-sm'>
                    If you believe this is an error or would like to explore
                    other options, please contact our team for further
                    assistance.{' '}
                </p>
            </div>
            <div className='_flex space-x-2 mx-4 pt-4'>
                <Button
                    id={`${baseId}-button-reduceLoan`}
                    onClick={handleChangeLoanUsage}
                >
                    Change Loan to Consumer
                </Button>
            </div>
            <div className='flex-center w-full'>
                <ContactBox />
            </div>
        </DisplayComponent>
    );
}
